import { SessionState } from 'stores/types';

export const initialState: SessionState = {
  requestId: '',
  sessionId: '',
};
